{
  "blue.1": "#0d1b2e",
  "blue.2": "#0f2440",
  "blue.3": "#13359d",
  "blue.4": "#1a4fc4",
  "blue.5": "#5599ff",
  "blue.6": "#4a8fe8",
  "blue.7": "#5599ff",
  "blue.8": "#adc9ff",
  "blue.9": "#c7daff",
  "blue.10": "#ebf3ff",
  "purple.1": "#1a1530",
  "purple.2": "#221a40",
  "purple.3": "#3a2870",
  "purple.4": "#5a3ea0",
  "purple.5": "#8e6afb",
  "purple.6": "#9b7cfc",
  "purple.7": "#b39aff",
  "purple.8": "#cdbff9",
  "purple.9": "#ddd7fc",
  "purple.10": "#eae9ff",
  "teal.1": "#0a1f1c",
  "teal.2": "#0f2e28",
  "teal.3": "#115746",
  "teal.4": "#1c7761",
  "teal.5": "#31d0aa",
  "teal.6": "#3dddb8",
  "teal.7": "#58d7b9",
  "teal.8": "#a7e6d7",
  "teal.9": "#ceeee6",
  "teal.10": "#ebf3f1",
  "green.1": "#0c1f14",
  "green.2": "#10301c",
  "green.3": "#1e4630",
  "green.4": "#2c5840",
  "green.5": "#58af7c",
  "green.6": "#3dac6d",
  "green.7": "#58af7c",
  "green.8": "#95d4aa",
  "green.9": "#c3e4ce",
  "green.10": "#e5f4ea",
  "magenta.1": "#2a0f1e",
  "magenta.2": "#3d1530",
  "magenta.3": "#780650",
  "magenta.4": "#c41d7f",
  "magenta.5": "#f759ab",
  "magenta.6": "#ff85c0",
  "magenta.7": "#ffadd2",
  "magenta.8": "#ffd6e7",
  "magenta.9": "#fff0f6",
  "magenta.10": "#fff5f9",
  "red.1": "#2a0f12",
  "red.2": "#3d1518",
  "red.3": "#5b0117",
  "red.4": "#9e2f34",
  "red.5": "#db4552",
  "red.6": "#e46969",
  "red.7": "#ebb8bb",
  "red.8": "#f8d9da",
  "red.9": "#fbeced",
  "red.10": "#fdf5f5",
  "orange.1": "#2a1a0f",
  "orange.2": "#3d2515",
  "orange.3": "#75300a",
  "orange.4": "#b85722",
  "orange.5": "#fd8f52",
  "orange.6": "#ff9f66",
  "orange.7": "#ffb066",
  "orange.8": "#f8d2b5",
  "orange.9": "#ffe6d9",
  "orange.10": "#fcfbf9",
  "yellow.1": "#2a2210",
  "yellow.2": "#3d3118",
  "yellow.3": "#735502",
  "yellow.4": "#c29c00",
  "yellow.5": "#fbdd73",
  "yellow.6": "#f9cc2d",
  "yellow.7": "#fbdd73",
  "yellow.8": "#fce5a5",
  "yellow.9": "#fbeeca",
  "yellow.10": "#fff8e5",
  "volcano.1": "#2b1510",
  "volcano.2": "#3d1e15",
  "volcano.3": "#871400",
  "volcano.4": "#d4380d",
  "volcano.5": "#ff7a45",
  "volcano.6": "#ff9c6e",
  "volcano.7": "#ffbb96",
  "volcano.8": "#ffd8bf",
  "volcano.9": "#fff2e8",
  "volcano.10": "#fff7f0",
  "geekblue.1": "#0d1228",
  "geekblue.2": "#131a3d",
  "geekblue.3": "#1d39c4",
  "geekblue.4": "#2f54eb",
  "geekblue.5": "#597ef7",
  "geekblue.6": "#85a5ff",
  "geekblue.7": "#adc6ff",
  "geekblue.8": "#d6e4ff",
  "geekblue.9": "#f0f5ff",
  "geekblue.10": "#f5f8ff",
  "lime.1": "#1a2a0f",
  "lime.2": "#253d15",
  "lime.3": "#3f6600",
  "lime.4": "#7cb305",
  "lime.5": "#bae637",
  "lime.6": "#d3f261",
  "lime.7": "#eaff8f",
  "lime.8": "#f4ffb8",
  "lime.9": "#fcffe6",
  "lime.10": "#fefff2",
  "gold.1": "#2a2210",
  "gold.2": "#3d3118",
  "gold.3": "#874d00",
  "gold.4": "#d48806",
  "gold.5": "#ffc53d",
  "gold.6": "#ffd666",
  "gold.7": "#ffe58f",
  "gold.8": "#fff1b8",
  "gold.9": "#fffbe6",
  "gold.10": "#fffdf2",
  "gray.1": "#1a1c20",
  "gray.2": "#1e2028",
  "gray.3": "#222530",
  "gray.4": "#252830",
  "gray.5": "#2c3038",
  "gray.6": "#4a5568",
  "gray.7": "#6b7a90",
  "gray.8": "#8e99ad",
  "gray.9": "#b3bcc9",
  "gray.10": "#dfe3e8",
  "gray.20": "#ebeef1",
  "gray.30": "#f5f6f8",
  "colorTextBase": "#e4e8ed",
  "colorTextLightSolid": "#FFFFFF",
  "colorBgBase": "#1a1c20",
  "lineWidth": 1,
  "borderRadius": 8,
  "sizeUnit": 4,
  "sizePopupArrow": 16,
  "controlHeight": 32,
  "opacityImage": 1,
  "sizeStep": 4,
  "colorPrimary": "#5599ff",
  "colorError": "#ef6b6b",
  "colorWarning": "#ffa54f",
  "colorSuccess": "#4ec98a",
  "colorInfo": "#8e99ad",
  "fontSize": 14,
  "size5XL": 64,
  "size4XL": 56,
  "size3XL": 48,
  "sizeXXL": 40,
  "sizeXL": 32,
  "sizeLG": 24,
  "sizeMD": 20,
  "sizeMS": 16,
  "size": 16,
  "sizeSM": 12,
  "sizeXS": 8,
  "sizeXXS": 4,
  "controlHeightXS": 16,
  "controlHeightSM": 24,
  "controlHeightLG": 40,
  "controlHeightXL": 48,
  "borderRadiusXS": 2,
  "borderRadiusSM": 4,
  "borderRadiusLG": 12,
  "borderRadiusXL": 24,
  "borderRadiusXXL": 32,
  "borderRadius3XL": 40,
  "borderRadius4XL": 48,
  "borderRadius5XL": 64,
  "borderRadiusOuter": 4,
  "colorText": "#e4e8ed",
  "colorTextSecondary": "rgba(228, 232, 237, 0.82)",
  "colorTextTertiary": "rgba(228, 232, 237, 0.64)",
  "colorTextQuaternary": "rgba(228, 232, 237, 0.45)",
  "colorFill": "rgba(228, 232, 237, 0.15)",
  "colorFillSecondary": "rgba(228, 232, 237, 0.10)",
  "colorFillTertiary": "rgba(228, 232, 237, 0.06)",
  "colorFillQuaternary": "rgba(228, 232, 237, 0.04)",
  "colorBgContainer": "#1a1c20",
  "colorBgLayout": "#1a1c20",
  "colorBgElevated": "#252830",
  "colorBgSpotlight": "rgba(23, 25, 32, 0.95)",
  "colorBorder": "rgba(228, 232, 237, 0.20)",
  "colorBorderSecondary": "rgba(228, 232, 237, 0.14)",
  "colorBorderTertiary": "rgba(228, 232, 237, 0.10)",
  "colorBorderInverse": "#1a1c20",
  "colorSplit": "rgba(228, 232, 237, 0.20)",
  "colorSplitSecondary": "rgba(228, 232, 237, 0.14)",
  "colorSplitTertiary": "rgba(228, 232, 237, 0.10)",
  "colorPrimaryBg": "#0d1b2e",
  "colorPrimaryBgHover": "#0f2440",
  "colorPrimaryBorder": "#5599ff",
  "colorPrimaryBorderHover": "#79b3ff",
  "colorPrimaryHover": "#79b3ff",
  "colorPrimaryBase": "#5599ff",
  "colorPrimarySubdued": "#1a2740",
  "colorPrimarySubduedHover": "#1f3355",
  "colorPrimarySubduedActive": "rgba(85, 153, 255, 0.3)",
  "colorPrimaryActive": "#adc9ff",
  "colorPrimaryTextHover": "#adc9ff",
  "colorPrimaryText": "#c7daff",
  "colorPrimaryTextActive": "#ebf3ff",
  "colorSuccessBg": "#0c1f14",
  "colorSuccessBgHover": "#10301c",
  "colorSuccessBorder": "#3dac6d",
  "colorSuccessBorderHover": "#58af7c",
  "colorSuccessHover": "#58af7c",
  "colorSuccessBase": "#3dac6d",
  "colorSuccessVariant": "#58af7c",
  "colorSuccessSubdued": "#1e4630",
  "colorSuccessSubduedHover": "#2c5840",
  "colorSuccessSubduedActive": "rgba(88, 175, 124, 0.3)",
  "colorSuccessActive": "#95d4aa",
  "colorSuccessTextHover": "#95d4aa",
  "colorSuccessText": "#c3e4ce",
  "colorSuccessTextActive": "#e5f4ea",
  "colorWarningBg": "#2a1a0f",
  "colorWarningBgHover": "#3d2515",
  "colorWarningBorder": "#ff9f66",
  "colorWarningBorderHover": "#ffb066",
  "colorWarningHover": "#ffb066",
  "colorWarningBase": "#ff9f66",
  "colorWarningSubdued": "#75300a",
  "colorWarningSubduedHover": "rgba(255, 176, 102, 0.3)",
  "colorWarningSubduedActive": "rgba(253, 143, 82, 0.3)",
  "colorWarningActive": "#f8d2b5",
  "colorWarningTextHover": "#f8d2b5",
  "colorWarningText": "#ffe6d9",
  "colorWarningTextActive": "#fcfbf9",
  "colorErrorBg": "#2a0f12",
  "colorErrorBgHover": "#3d1518",
  "colorErrorBorder": "#ef6b6b",
  "colorErrorBorderHover": "#f09090",
  "colorErrorHover": "#f09090",
  "colorErrorBase": "#ef6b6b",
  "colorErrorSubdued": "#5b0117",
  "colorErrorSubduedHover": "#760521",
  "colorErrorSubduedActive": "rgba(228, 105, 105, 0.3)",
  "colorErrorActive": "#f8d9da",
  "colorErrorTextHover": "#f8d9da",
  "colorErrorText": "#fbeced",
  "colorErrorTextActive": "#fdf5f5",
  "colorInfoBg": "#1a1a1a",
  "colorInfoBgHover": "#222222",
  "colorInfoBorder": "#999999",
  "colorInfoBorderHover": "#b3b3b3",
  "colorInfoHover": "#b3b3b3",
  "colorInfoBase": "#999999",
  "colorInfoSubdued": "#333333",
  "colorInfoSubduedHover": "rgba(153, 153, 153, 0.3)",
  "colorInfoSubduedActive": "rgba(179, 179, 179, 0.3)",
  "colorInfoActive": "#cccccc",
  "colorInfoTextHover": "#b3b3b3",
  "colorInfoText": "#cccccc",
  "colorInfoTextActive": "#e0e0e0",
  "colorBgMask": "rgba(0, 0, 0, 0.65)",
  "stepsDotSize": 8,
  "stepsCurrentDotSize": 10,
  "rateStarSize": 20,
  "colorFillContent": "rgba(228, 232, 237, 0.10)",
  "colorFillContentHover": "rgba(228, 232, 237, 0.15)",
  "colorFillAlter": "#1e2028",
  "colorBgContainerDisabled": "rgba(228, 232, 237, 0.07)",
  "colorBgContainerDisabledSubdued": "rgba(228, 232, 237, 0.04)",
  "colorBorderBg": "#252830",
  "colorTextPlaceholder": "rgba(228, 232, 237, 0.64)",
  "colorTextDisabled": "rgba(228, 232, 237, 0.32)",
  "colorTextHeading": "#e4e8ed",
  "colorTextLabel": "#e4e8ed",
  "colorTextDescription": "rgba(228, 232, 237, 0.64)",
  "colorBgTextHover": "#333840",
  "colorBgTextActive": "#3d4350",
  "colorIcon": "rgba(228, 232, 237, 0.64)",
  "colorIconHover": "#e4e8ed",
  "colorLink": "#5599ff",
  "colorLinkHover": "#79b3ff",
  "colorLinkActive": "#adc9ff",
  "colorHighlight": "#ff9f66",
  "controlOutline": "#0d1b2e",
  "colorWarningOutline": "#2a1a0f",
  "colorErrorOutline": "#2a0f12",
  "fontSizeIcon": 12,
  "controlLineWidth": 1,
  "controlOutlineWidth": 2,
  "controlItemBgHover": "#121E33",
  "controlItemBgActive": "#162850",
  "controlItemBgActiveHover": "#1a3366",
  "controlInteractiveSize": 16,
  "controlItemBgActiveDisabled": "rgba(228, 232, 237, 0.07)",
  "controlTmpOutline": "rgba(228, 232, 237, 0.04)",
  "opacityLoading": 0.65,
  "padding": 16,
  "paddingXXS": 4,
  "paddingXS": 8,
  "paddingSM": 12,
  "paddingMD": 20,
  "paddingLG": 24,
  "paddingXL": 32,
  "paddingXXL": 40,
  "padding3XL": 48,
  "padding4XL": 56,
  "padding5XL": 64,
  "margin": 16,
  "marginXXS": 4,
  "marginXS": 8,
  "marginSM": 12,
  "marginMD": 20,
  "marginLG": 24,
  "marginXL": 32,
  "marginXXL": 40,
  "margin3XL": 48,
  "margin4XL": 56,
  "margin5XL": 64,
  "controlPaddingHorizontal": 12,
  "controlPaddingHorizontalSM": 8,
  "paddingContentHorizontalLG": 24,
  "paddingContentVerticalLG": 16,
  "paddingContentHorizontal": 16,
  "paddingContentVertical": 12,
  "paddingContentHorizontalSM": 16,
  "paddingContentVerticalSM": 8,
  "boxShadow": "0px 1px 2px 0px rgba(0, 0, 0, 0.20), 0px 1px 6px -1px rgba(0, 0, 0, 0.16), 0px 2px 4px 0px rgba(0, 0, 0, 0.14)",
  "boxShadowSecondary": "0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.40), 0px 9px 28px 8px rgba(0, 0, 0, 0.20)",
  "boxShadowCard": "0px 1px 2px -2px rgba(0, 0, 0, 0.40), 0px 3px 6px 0px rgba(0, 0, 0, 0.32), 0px 5px 12px 4px rgba(0, 0, 0, 0.24)",
  "colorItemText": "rgba(228, 232, 237, 0.72)",
  "colorItemTextDisabled": "rgba(228, 232, 237, 0.30)",
  "focusPrimary": "0px 0px 0px 2px rgba(85, 153, 255, 0.35)",
  "focusError": "0px 0px 0px 2px rgba(239, 107, 107, 0.35)",
  "focusWarning": "0px 0px 0px 2px rgba(255, 165, 79, 0.35)",
  "tooltipBg": "#252830",
  "segmentedBgColorSelected": "#353B45",
  "segmentedGroupBg": "rgba(228, 232, 237, 0.06)",
  "colorMenuDarkBg": "#151720",
  "colorMenuSubItemBg": "#1a1c20",
  "boxShadowButtonSolid": "0px 2px 0px 0px rgba(0, 0, 0, 0.4)",
  "paddingTooltipContentVertical": 6,
  "fontSizeSM": 12,
  "fontSizeLG": 16,
  "fontSizeXL": 18,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 32,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 22,
  "fontSizeHeading5": 20,
  "next": {
    "controlHeight": "28px",
    "controlHeightLG": "32px",
    "controlHeightSM": "22px",
    "borderRadius": "6px",
    "boxShadow": "0px 2px 4px 0px rgba(0,0,0,0.20), 0px 1px 6px -1px rgba(0,0,0,0.16), 0px 1px 2px 0px rgba(0,0,0,0.24)",
    "colorBorder": "#353B45",
    "colorBorderHover": "#4A5568",
    "colorBorderFocus": "#5599FF",
    "boxShadowHover": "0px 0px 0px 2px rgba(74, 85, 104, 0.25)",
    "boxShadowFocus": "0px 0px 0px 2px rgba(85, 153, 255, 0.20)",
    "boxShadowFocusGreen": "0px 0px 0px 2px rgba(78, 201, 138, 0.20)",
    "colorBgField": "#1e2028",
    "colorBgDisabled": "#171920",
    "colorBgOptionActive": "#30343D",
    "colorText": "#D0D5DD",
    "colorTextPlaceholder": "#5A6478",
    "colorError": "#EF6B6B",
    "boxShadowError": "0px 0px 0px 2px rgba(239, 107, 107, 0.20)",
    "fontSize100": "13px",
    "fontSize200": "14px",
    "fontWeight400": 400,
    "fontWeight500": 500,
    "fontWeight600": 600,
    "palette": {
      "grey0": "#1a1c20",
      "grey25": "#1f2129",
      "grey50": "#242732",
      "grey75": "#2c3038",
      "grey100": "#353B45",
      "grey200": "#4A5568",
      "grey300": "#627085",
      "grey400": "#7A8599",
      "grey500": "#8E99AD",
      "grey600": "#A3AEC2",
      "grey700": "#B8C2D4",
      "grey800": "#D0D5DD",
      "grey900": "#E8ECF0",
      "blue50": "#121E33",
      "blue500": "#5599FF",
      "red50": "#261018",
      "red100": "#4D1A2D",
      "red500": "#EF6B6B",
      "amber50": "#261A10",
      "amber100": "#4D3018",
      "amber500": "#FFA54F",
      "green50": "#0E2118",
      "green500": "#4EC98A",
      "green525": "#5BD49A",
      "lime50": "#EFFEDA",
      "lime100": "#B5E98F",
      "lime700": "#2C671D",
      "lilac50": "#ECE6FF",
      "mint50": "#C7F5D3",
      "peach50": "#FFE8DC"
    },
    "tagSelect": {
      "colorTagBackground": "#DCCE9E",
      "colorTagBorder": "#B9AD85",
      "colorTagText": "#353A44",
      "colorTagChipBg": "#474e5a",
      "colorTagChipBorder": "#596171",
      "colorTagChipText": "#FFFFFF",
      "colorTagChipXHover": "#000"
    },
    "identity": {
      "iconFg": "#21252C",
      "entityBg": "#ECE6FF",
      "eventBg": "#C7F5D3",
      "audienceBg": "#FFE8DC",
      "relationBg": "#ECE6FF",
      "brandBlue": "#105ED5",
      "aiGradientStart": "#1AB6E5",
      "aiGradientMid": "#1A5EE5",
      "aiGradientEnd": "#6B1AE5",
      "logoPlateBg": "#FFFFFF",
      "logoPlateInset": "#1A1C2073"
    },
    "coachMark": {
      "scrim": "#00000066",
      "cardBorder": "#353B45"
    },
    "sourceCategory": {
      "text": "#21252C",
      "event": "#CDBFF9",
      "extract": "#A7E6D7",
      "retl": "#C7DAFF",
      "retlText": "#FFFFFF",
      "retlAudience": "#FF7A45",
      "retlTable": "#C41D7F",
      "retlModel": "#7447FC"
    }
  }
}
